import { colors } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const styles = makeStyles((theme) => ({
  noInteractionTypography: {
    color: colors.grey[500],
  },
}))

export default styles
